import AbstractFileInput from './AbstractFileInput';

export default class MultipleFiles extends AbstractFileInput {
    constructor() {
        super();
    }

    getBaseConfig() {
        var data = {
            theme: this.getTheme(),
            language: this.getLang(),
            showCaption: false,
            uploadUrl: this.$fileinput.data('upload-url'),
            uploadAsync: false,
            overwriteInitial: false
        };

        if (this.$fileinput.data('show-remove') == 'false') {
            data.showRemove = false;
            data.fileActionSettings.showRemove = false;
        }

        var $initDocument = $('div[name="initDocuments"]', this);

        if ($initDocument.data('preview-config')) {
            $.extend(data, {
                initialPreviewConfig: $initDocument.data('preview-config')
            });
        }

        if ($initDocument.data('preview')) {
            $.extend(data, {
                initialPreview: $initDocument.data('preview')
            });
        }

        return data;
    }

    setEvents() {
        super.setEvents();

        this.$fileinput.on('filesorted', function (e, params) {
            if (!this.$fileinput.data('upload-url'))
                return false;

            var datas = [];

            $.each(params.stack, function (i, item) {
                datas.push({id: item.document_id, position: i});
            });

            if (datas.length) {
                $.ajax({
                    url: this.$fileinput.data('upload-url'),
                    method: 'PUT',
                    data: {'uploads': datas},
                });
            }
        });
    }
}
